import { gql } from '@apollo/client';

import { threadAnswerFragment } from '../fragments';

export default gql`
  mutation CreateThreadAnswer(
    $courseId: String!
    $threadId: String!
    $input: CreateThreadAnswerInput!
  ) {
    createThreadAnswer(courseId: $courseId, threadId: $threadId, input: $input)
      @rest(
        type: "ThreadAnswer"
        path: "courses/{args.courseId}/threads/{args.threadId}/answers"
        method: "POST"
      ) {
      ...ThreadAnswer
    }
  }
  ${threadAnswerFragment}
`;
